import React from "react";
import { Link } from "wouter";

import {
  countryLabelOf,
  pricingLabelOf,
} from "../../components/InstrumentEditor";
import { instrumentLink } from "../../paths";
import {
  ActionLink,
  Card,
  CardHeader,
  CardTitle,
  DefinitionList,
} from "../../styles";
import { formatObservedAt } from "../../utils/format";
import { ResolvedFixDetailProps } from "../types";

export const ResolvedFixDetail: React.FC<ResolvedFixDetailProps> = ({
  resolution: { instrument, resolvedAt },
}) => {
  const { symbol, name, exchange, sourceCountry } = instrument;
  const pricingLabel = pricingLabelOf(
    instrument.manualPricingOnly,
    instrument.yahooSymbol,
  );

  return (
    <Card aria-label={`Fix recorded for ${symbol}`}>
      <CardHeader>
        <CardTitle>{symbol}</CardTitle>
      </CardHeader>
      <DefinitionList>
        <dt>Name</dt>
        <dd>{name}</dd>
        <dt>Exchange</dt>
        <dd>{exchange}</dd>
        <dt>Source country</dt>
        <dd>{countryLabelOf(sourceCountry)}</dd>
        <dt>Pricing</dt>
        <dd>{pricingLabel}</dd>
        <dt>Saved</dt>
        <dd>{formatObservedAt(resolvedAt)}</dd>
      </DefinitionList>
      <Link href={instrumentLink(instrument.id)} asChild>
        <ActionLink>Open instrument</ActionLink>
      </Link>
    </Card>
  );
};
